type Fn = (x: any) => any;

// eslint-disable-next-line  @typescript-eslint/no-unsafe-function-type
export const isFunction = (fn: unknown): fn is Function =>
  typeof fn === 'function' && !fn.toString().startsWith('class');

// left to right
export const pipe =
  (...fns: Fn[]) =>
  (x: any) =>
    fns.reduce((v: any, f: Fn) => f(v), x);

// right to left
export const compose =
  (...fns: Fn[]) =>
  (x: any) =>
    fns.reduceRight((v: any, f: Fn) => f(v), x);

// debugging tool
export const trace = (label: string) => (x: any) => {
  console.log(`== ${label}:  ${x}`); // eslint-disable-line no-console
  return x;
};
